const radios = document.querySelectorAll('input[type="radio"][name="variant_id"]');

radios.forEach(radio => {
  // Set initial state on page load
  if (radio.checked) {
    radio.parentNode.classList.add('selected');
  }

  radio.addEventListener('change', () => {
    radios.forEach(r => {
      r.parentNode.classList.remove('selected');
    });

    if (radio.checked) {
      radio.parentNode.classList.add('selected');
    }
  });
});


// get the submit button
const submitBtn = document.querySelector('#submit-now');

try{
  // add click event listener to the submit button
  submitBtn.addEventListener('click', (event) => {
    // prevent the default form submission
    event.preventDefault();

    // get the checked variant
    const checkedVariant = document.querySelector('input[name="variant_id"]:checked');

    // check if variant is selected
    if (checkedVariant) {
      // get the variant id
      const variantId = checkedVariant.value;
      const AccountNumber = sessionStorage.getItem("Account Number");
      const carrier = sessionStorage.getItem("Carrier");

     

      // redirect the user to checkout with the selected variant
      // window.location.href = url;
      if( AccountNumber && carrier){
        const url  = `https://astorline.astorchocolate.com/cart/${ variantId }:1?attributes[Account-Number]=${ AccountNumber }&attributes[Carrier]=${ carrier }`
        console.log(url)
        window.open(url, '_blank');
      }else{
        let errorTextPlacement = document.querySelector("#cart-errors-shipping-info");
        errorTextPlacement.textContent = `Please provide the carrier account information`;
      }
    }
  });
}catch{
  console.log("submitBtn not defined");
}

const unauthorized = document.querySelector('#unauthorized');

try{
  unauthorized.addEventListener('click', (event) => {
    document.querySelector("#login-popup").classList.remove('hidden');
  })
}catch{
  console.log("login-popup not defined");
}





